import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const NoAccessIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Zm-2 0a9.958 9.958 0 0 0-2.257-6.329L9.671 23.743A9.958 9.958 0 0 0 16 26c5.523 0 10-4.477 10-10ZM8.257 22.329 22.33 8.257A9.959 9.959 0 0 0 16 6C10.477 6 6 10.477 6 16c0 2.401.846 4.605 2.257 6.329Z" />
  </BaseIcon>
);
